import { inject } from '@angular/core';
import { selectSelectedAccount } from '@mkp/account/state';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { map } from 'rxjs/operators';

export function isBoUserWithoutSelectedAccountGuard() {
  const store = inject(Store);
  return store.select(selectIsBoUser).pipe(
    concatLatestFrom(() => store.select(selectSelectedAccount)),
    map(([isBoUser, selectedAccount]) => isBoUser && !selectedAccount)
  );
}
